// import { pagesModule, buildBreadcrumbs } from '@/store/database/pagesModule';
// import { contextsModule } from '@/store/database/contextsModule';
// import { generateRandomId } from '@/magnetarSetup';
// import { Timestamp } from 'firebase/firestore';
// import useContext from '@/views/Context/use/useContext';
// import { currentUserId } from '@/store/useAuth';

import { reactive, ref, computed } from '@vue/composition-api';

export const focusedEl = ref(null);

export const setFocusedEl = v => (focusedEl.value = v);
